import { getCompetitorsPricesRowClassName } from './utils'

import type { TableData } from '@app/types/table'
import type { ResponseDto } from '@app/api/dtos'
import type { CompetitorsPricesDataSource } from '../types'
import type { MonitoringTaskResultItemsDto } from '@app/api/routes/monitoringTasks/dtos'

export const adaptCompetitorsPricesTableData = (
  monitoringTaskResultItemsResponse: ResponseDto<MonitoringTaskResultItemsDto>,
  taskId: number
): TableData<CompetitorsPricesDataSource> => {
  const { count, results: monitoringTaskResultItems } = monitoringTaskResultItemsResponse

  const dataSource: CompetitorsPricesDataSource[] = monitoringTaskResultItems.map(dto => ({
    monitoringId: taskId,
    key: dto.id,
    competitor: dto.competitor?.text ?? null,
    productCode: dto.product?.code ?? null,
    howToMonitor: dto.howToMonitor ?? null,
    barcodes: dto.product.barcodes?.join(', ') ?? null,
    productName: dto.product?.name ?? null,
    regularPrice: dto.regularPrice,
    promoPrice: dto.promoPrice,
    matchingStatus: dto.matchingStatus,
    note: dto.note,
    rowClassName: getCompetitorsPricesRowClassName(dto.abnormalState) ?? ''
  }))

  return { count, dataSource }
}
